import React from 'react';
import { BadgePercentIcon, HandshakeIcon, TargetIcon } from 'lucide-react';
import { Reveal } from './showcase/Reveal';
import { AccountabilityDashboard } from './showcase/AccountabilityDashboard';
const principles: {
  title: string;
  body: string;
  icon: typeof HandshakeIcon;
}[] = [{
  title: 'The retainer means something',
  icon: HandshakeIcon,
  body: 'Month to month, no annual contract. If we stop producing, you stop paying.'
}, {
  title: 'We never touch your commission',
  icon: BadgePercentIcon,
  body: 'No per-lead fees, no per-minute meters, no cut of your deals. Your closings are 100% yours.'
}, {
  title: 'We know where deals stall',
  icon: TargetIcon,
  body: 'Two years at Zillow as a Senior Elite Account Executive. Kevin watched great agents lose to faster ones.'
}];
export function Principles() {
  return <section id="principles" aria-label="How Viridia operates" className="border-b border-white/5 bg-ink-800" data-id="element-176" data-mp="30zss2jwqv54r">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-24" data-id="element-177" data-mp="yw3m0qj1y10w">
        <ul className="grid gap-5 md:grid-cols-3" data-id="element-178" data-mp="twr48k71fk56">
          {principles.map((item, index) => {
          const Icon = item.icon;
          return <li key={item.title} className="h-full" data-id="element-179" data-mp="p4hg99phgu5j" data-mpi={index}>
                <Reveal delay={0.06 * index} className="h-full" data-id="element-180" data-mp="l4yukbpu8f1n">
                  <div className="flex h-full flex-col rounded-xl border border-white/10 bg-ink-700 p-7" data-id="element-181" data-mp="l2mfq7fdmkst">
                    <span className="flex h-10 w-10 items-center justify-center rounded-lg border border-brand/30 bg-brand/10" data-id="element-182" data-mp="g2zt57dnrs7c">
                      <Icon className="h-5 w-5 text-brand" aria-hidden="true" data-id="element-183" data-mp="66n10dxrhmep" />
                    </span>
                    <h2 className="mt-6 font-display text-lg font-semibold tracking-tight text-white" data-id="element-184" data-mp="26cu8z25arys">
                      {item.title}
                    </h2>
                    <p className="mt-3 text-sm leading-relaxed text-white/60" data-id="element-185" data-mp="20iuwpthwq7bj">
                      {item.body}
                    </p>
                  </div>
                </Reveal>
              </li>;
        })}
        </ul>

        <Reveal className="mt-12" data-id="element-186" data-mp="3utbbr6wryyxp">
          <p className="text-sm text-white/55" data-id="element-187" data-mp="3uuckv5u8dbcs">
            The retainer buys accountability. This lands in your inbox every Friday.
          </p>
          <div className="mt-5" data-id="element-188" data-mp="3l2qebmsu80gd">
            <AccountabilityDashboard data-id="element-189" data-mp="3l41df9bc8k15" />
          </div>
        </Reveal>
      </div>
    </section>;
}